import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import show_stl_svg from '../../../assets/img/SVG_icons/Top/reference_operation/show_reference_model.svg';
import { img } from '@phi/components';
import { SessionType } from '@phi/authentication/frontend';
import { hide_reference_stl_model, show_reference_stl_model } from '@frontend/scene';
import ShowSTLTooltip from './ShowSTLTooltip';

export const ShowSTLIcon = show_stl_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
        session_type: { required: true, type: null as any as PropType<Set<SessionType>> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Show/Hide STL reference models';
        },

        disabled() {
            return !this.state.loaded
                || this.state.imported_stl_models.length === 0
                || (
                    this.state.framework !== 'onshape'
                    && !this.session_type.has('onshape')
                );
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.state.showing_reference_stl)
                hide_reference_stl_model();
            else
                show_reference_stl_model();
        },
    },

    render() {
        return h(BarButton, {
            id: 'show-stl-model-button',
            tippy: 'top',
            onClick: this.onClick,
            disabled: this.disabled,
            selected: this.state.tut_stage === 13,
            active: this.state.showing_reference_stl,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(show_stl_svg, this.alt),
            tooltip: ShowSTLTooltip,
        });
    },
});
